export const ProductIcon = () => (
  <svg width="48" height="48" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.588 9.45837L27.7224 13L24.1807 19.1344L10.6343 22.7641L8.04163 13.0881L21.588 9.45837Z"
      fill="#8A8A8A"
    />
    <path d="M21 8.00001L32 7.99999V19L19 32L8 21L21 8.00001Z" fill="black" />
    <circle cx="28.5" cy="11.5" r="1.5" fill="white" />
  </svg>
);

export const CampaignIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(5.4, 9)">
      <path d="M5.813 18.6L0 12.788L12.788 0L18.614 5.8L5.813 18.6Z" fill="#8A8A8A" />
    </g>
    <g transform="translate(11.208, 9)">
      <path
        d="M0 18.6L3.586 22.185L9.725 16.046L10.928 17.25L4.789 23.389L7.998 26.597L14.136 20.459L15.34 21.663L9.202 27.8L12.788 31.386L31.387 12.788L18.601 0L0 18.6Z"
        fill="black"
      />
    </g>
    <g transform="translate(14.117, 9)">
      <path
        d="M13.951 13.802C12.852 14.901 11.071 14.901 9.973 13.802L0 4.069L4.069 0L13.951 9.825C15.049 10.923 15.049 12.704 13.951 13.802Z"
        fill="#8A8A8A"
      />
    </g>
  </svg>
);

export const CuratorShopIcon = () => (
  <svg width="48" height="48" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="11" width="20" height="20" fill="black" />
    <path d="M19 31L19 24L21 24L21 31H19Z" fill="white" />
    <path d="M10 9L6.5 16H33.5L30 9H10Z" fill="#8A8A8A" />
  </svg>
);
